//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment' // 时间转换
import subNav from '~/components/common/subNav.vue' // 面包屑导航
import liveRotation from '~/components/liveroom/liveRotation' // 轮播图
import liveTab from '~/components/liveroom/liveTab.vue' // Tab栏
import liveList from '~/components/liveroom/liveList.vue' // list
import emptyData from '~/components/common/emptyData.vue'
import { serverlog } from '~/utils/utils'
export default {
  name: 'LiveRoom',
  components: {
    'sub-nav': subNav, // 面包屑导航
    'live-rotation': liveRotation, // 轮播图
    'live-tab': liveTab, // tab栏
    'live-list': liveList, // 列表
    'empty-data': emptyData
  },
  asyncData ({ $api, app, store, res, $winstonLog, route }) {
    try {
      const liveRotation = $api.liveroom.liveRotation({ // 轮播图
        ptn: -1
      }).catch(() => {
        console.log('liveRotation轮播图错误')
      })
      const liveList = $api.liveroom.liveList({ // 列表初始化
        liveLanguage: 'all', // 直播语言
        liveStatus: 0, // 直播状态
        // userId: '', // 用户id
        pageIndex: 1, // 页码
        pageSize: 8 // 页大小,
      }).catch(() => {
        console.log('liveList列表')
      })
      return Promise.all([liveRotation, liveList]).then((result) => {
        result[1] && result[1].liveListInfo && result[1].liveListInfo.items.forEach((item) => {
          item.show_time = moment(item.wiki_timestamp_start).format('MM/DD HH:mm')
          item.year = moment(item.wiki_timestamp_start).format('YYYY')
          item.day = moment(item.wiki_timestamp_start).format('MM/DD')
          item.hour = moment(item.wiki_timestamp_start).format('HH:mm')
        })
        return {
          liveRotation: result[0] && result[0], // 轮播图
          liveLangInfo: result[1] && result[1].liveLanguageInfo && result[1].liveLanguageInfo.items, // 直播语言
          liveListInfo: result[1] && result[1].liveListInfo && result[1].liveListInfo.items, // 直播列表
          liveListTotal: result[1] && result[1].liveListInfo && result[1].liveListInfo.total, // 直播总数
          liveListMTotal: result[1] && result[1].liveListInfo && result[1].liveListInfo.total // M站直播总数
        }
      }).catch((err) => {
        serverlog(err, route, store, $winstonLog)
        return { err }
      })
    } catch (errr) {
      console.log(errr, '直播获取失败')
    }
  },
  data () {
    return {
      nav_data: [{ link: '/', text: '首页', type: 'a' }, { link: '#', text: '直播', type: 'span' }], // 面包屑导航
      live_tab: [{ text: this.$v('全部'), code: 0 }, { text: this.$v('直播中'), code: 1 }, { text: this.$v('预告'), code: 2 }, { text: this.$v('回放'), code: 3 }], // tab栏
      liveRotation: [], // 轮播图数据
      liveLangInfo: [], // 直播语言
      liveListInfo: [], // 直播列表
      liveListTotal: 0, // 直播总数
      liveListMTotal: 0, // m端直播总数
      liveState: 0, // 直播状态
      liveLang: 'all', // 直播语言
      page: {
        pageSize: 8,
        pageIndex: 1
      }
    }
  },
  head () {
    return {
      title: this.$t('20465'), /* .replace(/\{0\}/g, `${this.$store.state.getCountry.name}` */
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('20530')
        },
        {
          property: 'og:image',
          content: 'https://resources1.interface003.com/web20/img/wiki-ico.png'
        }
      ]
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    getListswitch (i) { // 列表数据状态切换
      this.liveState = i
      this.page.pageIndex = 1
      this.getList()
    },
    getListLang (i) { // 列表数据语言切换
      this.liveLang = i
      this.page.pageIndex = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.page.pageIndex = val
      this.getList()
    },
    async getList () { // 获取列表分页
      // if (this.liveState != 0) this.page.pageIndex = 1
      const { liveListInfo } = await this.$api.liveroom.liveListpaging({
        liveLanguage: this.liveLang, // 直播语言
        liveStatus: this.liveState, // 直播状态
        pageIndex: this.page.pageIndex, // 页码
        pageSize: this.page.pageSize // 页大小
      })
      liveListInfo && liveListInfo.items.forEach((item) => {
        item.show_time = moment(item.wiki_timestamp_start).format('MM/DD HH:mm')
        item.year = moment(item.wiki_timestamp_start).format('YYYY')
        item.day = moment(item.wiki_timestamp_start).format('MM/DD')
        item.hour = moment(item.wiki_timestamp_start).format('HH:mm')
      })
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.liveListInfo = liveListInfo.items
      this.liveListTotal = liveListInfo.total
      // console.log('liveListInfo.total: ', liveListInfo.total)
    },
    async getListMM () { // 获取列表分页
      this.page.pageIndex++
      const { liveListInfo } = await this.$api.liveroom.liveListpaging({
        liveLanguage: this.liveLang, // 直播语言
        liveStatus: this.liveState, // 直播状态
        pageIndex: this.page.pageIndex, // 页码
        pageSize: this.page.pageSize // 页大小
      })
      liveListInfo && liveListInfo.items.forEach((item) => {
        item.show_time = moment(item.wiki_timestamp_start).format('MM/DD HH:mm')
        item.year = moment(item.wiki_timestamp_start).format('YYYY')
        item.day = moment(item.wiki_timestamp_start).format('MM/DD')
        item.hour = moment(item.wiki_timestamp_start).format('HH:mm')
        this.liveListInfo.push(item)
      })
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.liveListMTotal = liveListInfo.items.length < 8 ? 0 : liveListInfo.total
      // console.log('liveListInfo.total: ', liveListInfo.total)
    }
  }
}
